import Login from '../../services/Login';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { useState } from "react";
import { Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Typography } from "@mui/material";
import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import MenuIcon from '@mui/icons-material/Menu';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PersonIcon from '@mui/icons-material/Person';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import LogoutIcon from '@mui/icons-material/Logout';
import AssignmentIcon from '@mui/icons-material/Assignment';

const loginService = new Login();

export default function Header() {
  const path = window.location.pathname;
  const [open, setOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  const { mutate } = useMutation({
    mutationKey: ['LOGOUT'],
    mutationFn: async () => {
      toast.warn('Saindo!')
      const loggedData = localStorage.getItem('loggedData');
      if (loggedData) {
        const parsed = JSON.parse(loggedData);
        await loginService.logout(parsed?.userToken);
        localStorage.clear();
        window.location.href = window.location.origin + "/";
      }
    }
  })

  const drawerWidth = 180;

  const openedMixin = (theme: Theme): CSSObject => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
  });

  const closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(${theme.spacing(8)} + 1px)`,
    },
  });

  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));
  interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
  }

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })<AppBarProps>(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
      {
        props: ({ open }) => open,
        style: {
          marginLeft: drawerWidth,
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        },
      },
    ],
  }));

  const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme }) => ({
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      boxSizing: 'border-box',
      variants: [
        {
          props: ({ open }) => open,
          style: {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
          },
        },
        {
          props: ({ open }) => !open,
          style: {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
          },
        },
      ],
    }),
  );

  function listItemButtonStyle(value: string) {
    return ({
      backgroundColor: path === value ? '#614BA6' : 'inherit',
      color: path === value ? '#FFFFFF' : 'gray',
      minHeight: 48,
      px: 2.5,
      justifyContent: open ? 'initial' : 'center'
    })
  }
  function listItemIcon(value: string) {
    return ({
      color: path === value ? '#FFFFFF' : 'gray',
      minWidth: 0,
      justifyContent: 'center',
      mr: open ? 3 : 'auto',
    })
  }

  return (
    <>
      <AppBar sx={{ backgroundColor: '#614BA6' }} position="fixed" open={open}>
        <Toolbar>
          {!open && <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() => setOpen(!open)}
            edge="start"
          >
            <MenuIcon />
          </IconButton>}
          <Typography variant="h6" noWrap component="div">
            Interface administrativa Axyma
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={() => setOpen(!open)}>
            <ArrowBackIosIcon />
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List sx={{ width: 'fit-content' }}>
          <ListItem
            onClick={() => navigate('/empresas')}
            key={'Empresas'}
            disablePadding
            sx={{ display: 'block' }}>
            <ListItemButton sx={listItemButtonStyle('/empresas')} >
              <ListItemIcon sx={listItemIcon('/empresas')}>
                <CorporateFareIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Empresas'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
          <ListItem
            onClick={() => navigate('/dashboard')}
            key={'dashboard'}
            disablePadding sx={{ display: 'block' }}>
            <ListItemButton sx={listItemButtonStyle('/dashboard')}>
              <ListItemIcon sx={listItemIcon('/dashboard')}>
                <LeaderboardIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Dashboard'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
          <ListItem
            onClick={() => navigate('/cadastro-modelo')}
            key={'cadastro-modelo'}
            disablePadding sx={{ display: 'block' }}>
            <ListItemButton sx={listItemButtonStyle('/cadastro-modelo')}>
              <ListItemIcon sx={listItemIcon('/cadastro-modelo')}>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Cadastros-Modelo'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
          <ListItem
            onClick={() => navigate('/users')}
            key={'users'}
            disablePadding sx={{ display: 'block' }}>
            <ListItemButton sx={listItemButtonStyle('/users')}>
              <ListItemIcon sx={listItemIcon('/users')}>
                <PersonIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Usuários'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
          <ListItem
            onClick={() => navigate('/settings')}
            key={'configuracoes'}
            disablePadding sx={{ display: 'block' }}>
            <ListItemButton sx={listItemButtonStyle('/settings')}>
              <ListItemIcon sx={listItemIcon('/settings')}>
                <AppSettingsAltIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Configurações'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
        </List>
        <List style={{ marginTop: `auto` }} >
          <ListItem onClick={() => mutate()}>
            <ListItemButton
              sx={[
                {
                  color: 'gray',
                  minHeight: 48,
                  px: 2.5,
                },
                open ? { justifyContent: 'initial', } : { justifyContent: 'center' }
              ]}
            >
              <ListItemIcon
                sx={[{
                  minWidth: 0,
                  justifyContent: 'center',
                },
                open ? { mr: 3 } : { mr: 'auto' }
                ]}
              >
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText
                primary={'Sair'}
                sx={[open ? { opacity: 1 } : { opacity: 0 }]}
              />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
      </Drawer>
    </>
  )
}
